/* eslint-disable import/no-unresolved */
import BaseElement from 'base-element'
import { html, css } from 'lit-all'
import * as paths from 'lib-paths'
import styles from 'lib-styles'
/* eslint-disable import/no-unresolved */
class SMSInput extends BaseElement {
  static get properties() {
    return {
      loading: { type: Boolean, reflect: true },
      error: { type: Boolean, reflect: true },
      customerId: { type: String },
    }
  }

  constructor() {
    super()
    this.error = false
    this.loading = false
    this.form = document.querySelector('.js-communication-preference-tel')
    this.submitBtn = this.form.querySelector('button[type="submit"]')
  }

  connectedCallback() {
    super.connectedCallback()
    setTimeout(() => {
      this.attachListeners()
    }, 500)
  }

  submitForm(customerId, phoneNumber) {
    const config = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ customerId, phoneNumber }),
    }

    const url = `${__THEME_GLOBALS__.accountPreferencesBaseUrl}/sms/update-number/`

    this.error = false
    this.loading = true
    this.submitBtn.disabled = true

    fetch(url, config)
      .then((res) => {
        console.log(res.json())
      })
      .catch((err) => {
        console.error(err)
        this.error = true
      })
      .finally(() => {
        this.loading = false
        this.submitBtn.disabled = false
      })
  }

  _renderIcons() {
    if (this.loading || this.error) {
      return html`
        <div class="account-communication-preferences__form-loader">
          ${this.loading ? paths.loadingSpinner : paths.error}
          <p class="p message">
            ${this.loading ? 'Saving...' : 'Error: Could not update'}
          </p>
        </div>
      `
    }
  }

  _handleInputChange() {
    const input = this.renderRoot.querySelector('sl-input')

    if (input.checkValidity()) {
      this.submitBtn.disabled = false
    }
  }

  attachListeners() {
    this.form.addEventListener('submit', (e) => {
      e.preventDefault()
      e.stopPropagation()

      if (input.checkValidity()) {
        this.submitForm(this.customerId, input.value.replace(/-/g, '').trim())
      }
      this.error = true
    })
  }

  render() {
    return html`
      <div>
        <sl-input
          type="tel"
          name="tel"
          @input=${this._handleInputChange}
          pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
        ></sl-input>

        ${this._renderIcons()}
      </div>
    `
  }

  static styles = [
    styles.toggleComponent,
    styles.spinnerAnimation,
    css`
      :host {
        display: block;
      }

      sl-input {
        display: flex;
        width: 300px;
        height: 100%;
        flex-direction: column;
        align-items: flex-start;
        padding: 16px;
        border: 1px solid black;
      }

      sl-input::part(form-control) {
        width: 100%;
      }
    `,
  ]
}

customElements.define('sms-input', SMSInput)
